import styled from 'styled-components';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';

export const IndicatorsContainer = styled(Box)
    .withConfig({ displayName: 'IndicatorsContainer' })
    .attrs({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 5,
        px: 1.5,
        py: 3 / 4,
    })``;

export const CloseButton = styled(Button)
    .withConfig({ displayName: 'CloseButton' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        top: 1,
        right: 1,
        zIndex: 5,
        width: 40,
        height: 40,
    }))``;
